import { subscribeToMessage } from '../../features/realtime/realtime.subscribe';
import {
  type RealtimeMessage,
  RealtimeMessageType,
  type RealtimeEvent,
} from '../../features/realtime/realtime.types';
import {
  type ScreenshareEventData,
  ScreenshareRequestPayload,
} from './screenshareState.types';
import { useEffect } from 'react';
import { useScreenshareTransitions } from './useScreenshareTransitions';
import { useAppSelector } from '../useReduxToolkit';
import { getScreenshareState } from '../../features/screenshare/screenshare.selectors';

export const useListenForScreenshare = (): void => {
  const {
    setReceivedRequest,
    setAcceptRequest,
    setRejectRequest,
    setCancelRequest,
    setStopScreenshare,
    setStoppedScreenshare,
  } = useScreenshareTransitions();
  const screenshareState = useAppSelector(getScreenshareState);

  // Keep in mind this useEffect is creating a state closure, so it might receive outdated values
  // of the store unless explicitly passed as dependencies

  useEffect(() => {
    const unsubscribe = subscribeToMessage({
      messageType: RealtimeMessageType.ScreenshareRequest,
      callback: onScreenshareRequest,
    });

    return () => unsubscribe();
  }, [screenshareState]);

  function onScreenshareRequest(
    message: RealtimeMessage,
    event: RealtimeEvent,
  ): void {
    const { eventName, eventData } = message.payload as {
      eventName: ScreenshareRequestPayload;
      eventData: ScreenshareEventData;
    };
    switch (eventName) {
      case ScreenshareRequestPayload.Request: {
        void setReceivedRequest(event.from.id);
        break;
      }
      case ScreenshareRequestPayload.Accept: {
        void setAcceptRequest();
        break;
      }
      case ScreenshareRequestPayload.Reject: {
        void setRejectRequest(eventData);
        break;
      }
      case ScreenshareRequestPayload.Cancel: {
        void setCancelRequest({ realtimeMemberId: event.from.id });
        break;
      }
      case ScreenshareRequestPayload.Stop: {
        void setStopScreenshare({ realtimeMemberId: event.from.id });
        break;
      }

      case ScreenshareRequestPayload.Stopped: {
        void setStoppedScreenshare();
        break;
      }

      default:
    }
  }
};
